import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70d0e400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "l-form-header" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "l-option" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#c0bebe","text-align":"center","width":"90%","padding":"5px"} }, "☝ 拖拽控件到布局容器内部", -1))
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_FormDesignRender = _resolveComponent("FormDesignRender")!
  const _component_vue_draggable_next = _resolveComponent("vue-draggable-next")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === 'DESIGN')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_vue_draggable_next, {
            class: "l-drag-from",
            list: _ctx._items,
            group: "form",
            options: { animation: 300, chosenClass: 'choose', sort: true },
            onStart: _cache[0] || (_cache[0] = ($event: any) => {
                    _ctx.drag = true;
                    _ctx.selectFormItem = null;
                }),
            onEnd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drag = false))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._items, (cp, id) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: id,
                  class: "l-form-item",
                  style: _normalizeStyle(_ctx.getSelectedClass(cp)),
                  onClick: _withModifiers(($event: any) => (_ctx.selectItem(cp)), ["stop"])
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", null, [
                      (cp.props.required)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
                        : _createCommentVNode("", true),
                      _createTextVNode(_toDisplayString(cp.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_icon, {
                        size: "2em",
                        onClick: ($event: any) => (_ctx.delItem(id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Close)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createVNode(_component_FormDesignRender, { config: cp }, null, 8, ["config"])
                  ])
                ], 12, _hoisted_3))
              }), 128))
            ]),
            _: 1
          }, 8, ["list"]),
          _hoisted_7
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.__items, (rows, rsi) => {
            return (_openBlock(), _createBlock(_component_el_row, {
              key: rsi + '_rows',
              gutter: 20
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows, (item, ri) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    key: ri + '_row',
                    span: 24 / rows.length
                  }, {
                    default: _withCtx(() => [
                      (item.name !== 'SpanLayout' && item.name !== 'Description')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: item.name + ri,
                            prop: item.id,
                            label: item.title
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormDesignRender, {
                                modelValue: _ctx._value[item.id],
                                "onUpdate:modelValue": ($event: any) => ((_ctx._value[item.id]) = $event),
                                mode: _ctx.mode,
                                config: item
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "mode", "config"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "label"]))
                        : (_openBlock(), _createBlock(_component_FormDesignRender, {
                            key: 1,
                            modelValue: _ctx._value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._value) = $event)),
                            mode: _ctx.mode,
                            config: item
                          }, null, 8, ["modelValue", "mode", "config"]))
                    ]),
                    _: 2
                  }, 1032, ["span"]))
                }), 128))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
  ]))
}